module.exports = __webpack_public_path__ + "img/1.39aa89b1.jpg";